exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-btn[data-v-7cc213d2]:before{display:none}", ""]);

// exports
